//@flow
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {makeStyles} from '@material-ui/core';
import {TRIGGER_FIELDS} from '../../const';
import ResponseSection from '../ResponseSection';
import InitMessageSection from '../InitMessageSection';
import {
  DEFAULT_TRIGGER_TYPE,
  getActionTypeForTriggerType,
} from '../../../../utils/triggerConfig';
import type {ActionType, TriggerType} from '../../../../../../../entities';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
}));

const setValueOptions = {shouldDirty: true, shouldValidate: true};

export default function ActionSection() {
  const classes = useStyles();
  const {register, setValue, watch} = useFormContext();

  const triggerType: TriggerType = watch(
    TRIGGER_FIELDS.triggerType,
    DEFAULT_TRIGGER_TYPE
  );
  const actionType: ActionType = getActionTypeForTriggerType(triggerType);

  useEffect(() => {
    // actionType is derived from triggerType; validateTriggerForm owns checks.
    register(TRIGGER_FIELDS.actionType);
  }, [register]);

  useEffect(() => {
    setValue(TRIGGER_FIELDS.actionType, actionType, setValueOptions);

    if (actionType === 'SEND_MESSAGE') {
      setValue(TRIGGER_FIELDS.provider, undefined, setValueOptions);
      setValue(TRIGGER_FIELDS.deviceId, '', setValueOptions);
      setValue(TRIGGER_FIELDS.templateName, '', setValueOptions);
      setValue(TRIGGER_FIELDS.templateLang, '', setValueOptions);
      setValue(TRIGGER_FIELDS.templateComponents, [], setValueOptions);
    }
  }, [actionType, setValue]);

  return (
    <div className={classes.root}>
      {actionType === 'SEND_MESSAGE' && <ResponseSection />}
      {actionType === 'SEND_INIT_MESSAGE' && <InitMessageSection />}
    </div>
  );
}
